import { render, staticRenderFns } from "./Techniques.vue?vue&type=template&id=13714180&scoped=true"
import script from "./Techniques.vue?vue&type=script&lang=js"
export * from "./Techniques.vue?vue&type=script&lang=js"
import style0 from "./Techniques.vue?vue&type=style&index=0&id=13714180&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13714180",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13714180')) {
      api.createRecord('13714180', component.options)
    } else {
      api.reload('13714180', component.options)
    }
    module.hot.accept("./Techniques.vue?vue&type=template&id=13714180&scoped=true", function () {
      api.rerender('13714180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Proposal/Techniques.vue"
export default component.exports